

// // ##########################################################################



// // Pull Mechanism - Working Code

// import React, { useState, useEffect, useRef } from "react";
// import { StableLocationProvider, useStableLocation } from "context/StableLocationContext";
// import { useStableNavigate } from "context/StableNavigateContext";

// import Grid from "@mui/material/Grid";
// import MDBox from "components/MDBox";
// import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
// import DashboardNavbar from "examples/Navbars/DashboardNavbar";
// import Footer from "examples/Footer";
// import Toolbar from "./components/toolbar";

// import FollowersCountChart from "./components/FollowersCountChart";
// import FollowersChangeChart from "./components/FollowersChangeChart";
// import FollowersGrowthRateChart from "./components/FollowersGrowthRateChart";
// import FollowersEngagementCountChart from "./components/FollowersEngagementCountChart";
// import FollowersEngagementBestDayChart from "./components/FollowersEngagementBestDayChart";
// import FollowersEngagementRateChart from "./components/FollowersEngagementRateChart";
// import FollowersSentimentTimelineChart from "./components/FollowersSentimentTimelineChart";
// import ContentChart from "./components/ContentChart";
// import ContentDistributionChart from "./components/ContentDistributionChart";
// import ContentTypeChart from "./components/ContentTypeChart";
// import ContentTypeEngagementChart from "./components/ContentTypeEngagementChart";
// import WordCloudChart from "./components/WordCloudChart";
// import ExecutiveSummary from "./components/ExecutiveSummary";

// import NoProfilesSelected from "./components/NoProfilesSelected";
// import { fetchReportData } from "utils/fetchReportData";
// import { predictFutureData } from "utils/prediction";

// import UserService from "services/user-service";
import WorkspaceService from "services/workspace-service";

// import dayjs from "dayjs";
// import utc from "dayjs/plugin/utc";
// import timezone from "dayjs/plugin/timezone";

// dayjs.extend(utc);
// dayjs.extend(timezone);

// // ----------------------------------------------------------------------
// // CHART REGISTRY WITH FEATURE MAPPING
// // ----------------------------------------------------------------------
// export const charts = [
//   { id: "executive-summary", title: "Executive Summary", category: "Summary", component: ExecutiveSummary, feature: "Default" },
//   { id: "followers-over-time-chart", title: "Subscribers Over Time", category: "Audience", component: FollowersCountChart, feature: "Audience Report" },
//   { id: "followers-change-over-time-chart", title: "Subscribers Change Over Time", category: "Audience", component: FollowersChangeChart, feature: "Audience Report" },
//   { id: "followers-growth-rate-over-time-chart", title: "Subscribers Growth Rate Over Time", category: "Audience", component: FollowersGrowthRateChart, feature: "Audience Report" },
//   { id: "engagement-over-time-chart", title: "Engagement Over Time", category: "Engagement", component: FollowersEngagementCountChart, feature: "Engagement Report" },
//   { id: "engagement-rate-over-time-chart", title: "Engagement Rate Over Time", category: "Engagement", component: FollowersEngagementRateChart, feature: "Engagement Report" },
//   { id: "engagement-over-day-chart", title: "Engagement Over Day", category: "Engagement", component: FollowersEngagementBestDayChart, feature: "Engagement Report" },
//   { id: "word-cloud-chart", title: "Word Cloud of Comments", category: "Sentiment", component: WordCloudChart, feature: "Word Cloud" },
//   { id: "followers-sentiment-timeline-chart", title: "Sentiment Timeline", category: "Sentiment", component: FollowersSentimentTimelineChart, feature: "Sentiment Timeline" },
//   { id: "content-distribution-chart", title: "Content Distribution", category: "Content", component: ContentDistributionChart, feature: "Default" },
//   { id: "content-type-chart", title: "Content Type", category: "Content", component: ContentTypeChart, feature: "Default" },
//   { id: "content-type-engagement-chart", title: "Content Type Engagement", category: "Content", component: ContentTypeEngagementChart, feature: "Default" },
//   { id: "content-performance-over-time-chart", title: "Content Performance Over Time", category: "Content", component: ContentChart, feature: "Content Drill Down" },
// ];

// // ----------------------------------------------------------------------
// // MAIN COMPONENT
// // ----------------------------------------------------------------------
// function InsightHubContent() {
//   const location = useStableLocation();
//   const navigate = useStableNavigate();

//   const [selectedProfiles, setSelectedProfiles] = useState([]);
//   const uniqueCategories = [...new Set(charts.map(c => c.category))];
//   const [selectedCategories, setSelectedCategories] = useState(uniqueCategories);

//   const [reportData, setReportData] = useState([]);
//   const [adjustedCurrentReportData, setAdjustedCurrentReportData] = useState([]);
//   const [previousReportData, setPreviousReportData] = useState([]);
//   const [adjustedPreviousReportData, setAdjustedPreviousReportData] = useState([]);
//   const [futureReportData, setFutureReportData] = useState([]);
//   const [dateRange, setDateRange] = useState([null, null]);

//   const [isLoading, setIsLoading] = useState(true);

//   // ENTITLEMENTS
//   const [entitlements, setEntitlements] = useState(null);
//   const [requiredPlansMap, setRequiredPlansMap] = useState({});
//   const [userPlan, setUserPlan] = useState("");

//   // CONTENT CHART REF
//   const contentChartRef = useRef(null);

//   const DEFAULT_CHART_DAYS = process.env.REACT_APP_DEFAULT_CHART_DAYS
//     ? parseInt(process.env.REACT_APP_DEFAULT_CHART_DAYS, 10)
//     : 14;

//   const [isPredictionEnabled, setIsPredictionEnabled] = useState(false);

//   const handleTogglePrediction = () => setIsPredictionEnabled(p => !p);

//   // ----------------------------------------------------------------------
//   // FETCH ENTITLEMENTS ONCE
//   // ----------------------------------------------------------------------
//   useEffect(() => {
//     async function loadEntitlements() {
//       try {
//         const res = await UserService.fetchUserEntitlements();
//         setEntitlements(res);

//         setUserPlan(res.plan);
//         setRequiredPlansMap(res.requiredPlans || {});
//       } catch (err) {
//         console.error("Failed loading entitlements:", err);
//       }
//     }
//     loadEntitlements();
//   }, []);

//   // ----------------------------------------------------------------------
//   // Keep existing report fetch logic untouched
//   // ----------------------------------------------------------------------
//   useEffect(() => {
//     if (location.state?.selectedProfiles?.length > 0) {
//       setSelectedProfiles(location.state.selectedProfiles);
//     }
//   }, [location.state]);

//   const fetchDatasets = async (fromRaw, toRaw) => {
//     setIsLoading(true);
//     const tz = dayjs.tz.guess();

//     const fromDate = dayjs(fromRaw).tz(tz).startOf("day").toDate();
//     const toDate = dayjs(toRaw).tz(tz).endOf("day").toDate();
//     const dateDifference = dayjs(toDate).diff(dayjs(fromDate), "day") + 1;

//     const previousToDate = dayjs(fromDate).subtract(1, "day").endOf("day").toDate();
//     const previousFromDate = dayjs(previousToDate).subtract(dateDifference - 1, "day").startOf("day").toDate();

//     const combinedFromDate = dayjs(previousFromDate).subtract(1, "day").startOf("day").toDate();

//     const allData = [];
//     for (const profile of selectedProfiles) {
//       const data = await fetchReportData([profile], combinedFromDate, toDate);
//       allData.push(...data);
//     }
//     const combinedData = allData;

//     const currentData = combinedData.map(profile => ({
//       ...profile,
//       data: profile.data.filter(d => new Date(d.date) >= fromDate && new Date(d.date) <= toDate),
//     }));

//     const adjustedCurrentData = combinedData.map(profile => ({
//       ...profile,
//       data: profile.data.filter(d => {
//         const dt = new Date(d.date);
//         return dt >= dayjs(fromDate).subtract(1, "day").toDate() && dt <= toDate;
//       }),
//     }));

//     const previousData = combinedData.map(profile => ({
//       ...profile,
//       data: profile.data.filter(d => {
//         const dt = new Date(d.date);
//         return dt >= previousFromDate && dt <= previousToDate;
//       }),
//     }));

//     const futureData = predictFutureData(currentData, dateDifference).map(profile => ({
//       ...profile,
//       data: profile.data,
//     }));

//     setReportData(currentData);
//     setAdjustedCurrentReportData(adjustedCurrentData);
//     setPreviousReportData(previousData);
//     setAdjustedPreviousReportData(previousData);
//     setFutureReportData(futureData);
//     setIsLoading(false);
//   };

//   useEffect(() => {
//     if (selectedProfiles.length > 0) {
//       const tz = dayjs.tz.guess();
//       const today = dayjs().tz(tz).endOf("day").toDate();
//       const last = dayjs().tz(tz).subtract(DEFAULT_CHART_DAYS, "day").startOf("day").toDate();
//       setDateRange([last, today]);
//       fetchDatasets(last, today);
//     }
//   }, [selectedProfiles]);

//   const handleDateChange = (newRange) => {
//     const tz = dayjs.tz.guess();
//     const [startRaw, endRaw] = newRange;
//     if (!startRaw || !endRaw) return;

//     const start = dayjs(startRaw).tz(tz).startOf("day").toDate();
//     const end = dayjs(endRaw).tz(tz).endOf("day").toDate();
//     setDateRange([start, end]);
//     fetchDatasets(start, end);
//   };

//   // ----------------------------------------------------------------------
//   // RENDER
//   // ----------------------------------------------------------------------
//   return (
//     <DashboardLayout>
//       <DashboardNavbar />

//       {/* No profiles */}
//       {selectedProfiles.length === 0 ? (
//         <NoProfilesSelected />
//       ) : (
//         <>
//           <Toolbar
//             onDateChange={handleDateChange}
//             onTogglePrediction={handleTogglePrediction}
//             isPredictionEnabled={isPredictionEnabled}
//             chartIds={charts.map(c => c.id)}
//             selectedCategories={selectedCategories}
//             setSelectedCategories={setSelectedCategories}
//             selectedProfiles={selectedProfiles}
//             dateRange={dateRange}
//             contentChartRef={contentChartRef}
//           />

//           {/* Charts Loop */}
//           {charts
//             .filter(c => c.category.toLowerCase() === "summary" || selectedCategories.includes(c.category))
//             .map(chart => {
//               const ChartComponent = chart.component;
//               const isContentChart = chart.id === "content-performance-over-time-chart";

//               // entitlement logic
//               const featureName = chart.feature;
//               let isEntitled = true;
//               let planRequired = "N/A";

//               if (featureName !== "Default") {
//                 const allowed = entitlements?.features || [];
//                 isEntitled = allowed.includes(featureName);
//                 planRequired = entitlements?.requiredPlans?.[featureName] || "Upgrade";
//               }

//               return (
//                 <div id={chart.id} key={chart.id}>
//                   <MDBox pt={0} pb={6}>
//                     <Grid container spacing={3} mt={2}>
//                       <Grid item xs={12} md={12}>
//                         <ChartComponent
//                           title={chart.title}
//                           datasets={reportData}
//                           previousdatasets={previousReportData}
//                           futuredatasets={futureReportData}
//                           adjustedcurrentdatasets={adjustedCurrentReportData}
//                           adjustedpreviousdatasets={adjustedPreviousReportData}
//                           isPredictionEnabled={isPredictionEnabled}
//                           isLoading={isLoading}
//                           selectedCategories={selectedCategories}
//                           ref={isContentChart ? contentChartRef : null}
//                           isEntitled={isEntitled}
//                           featureName={featureName}
//                           planRequired={planRequired}
//                         />
//                       </Grid>
//                     </Grid>
//                   </MDBox>
//                 </div>
//               );
//             })}
//         </>
//       )}

//       <Footer />
//     </DashboardLayout>
//   );
// }

// export default function InsightHub() {
//   return (
//     <StableLocationProvider>
//       <InsightHubContent />
//     </StableLocationProvider>
//   );
// }



// #####################################################

// // // Pull Mechanism - Working Code


// // comparedly-frontend/src/layouts/insight-hub/index.js
// import React, { useState, useEffect, useRef } from "react";
// import { StableLocationProvider, useStableLocation } from "context/StableLocationContext";
// import { useStableNavigate } from "context/StableNavigateContext";

// import Grid from "@mui/material/Grid";
// import MDBox from "components/MDBox";
// import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
// import DashboardNavbar from "examples/Navbars/DashboardNavbar";
// import Footer from "examples/Footer";
// import Toolbar from "./components/toolbar";

// // 🚀 IMPORTS for Modal
// import { Dialog, DialogContent, DialogTitle, IconButton } from "@mui/material";
// import CloseIcon from "@mui/icons-material/Close";
// import SocialStashModal from "layouts/social-stash/SocialStashModal";

// import FollowersCountChart from "./components/FollowersCountChart";
// import FollowersChangeChart from "./components/FollowersChangeChart";
// import FollowersGrowthRateChart from "./components/FollowersGrowthRateChart";
// import FollowersEngagementCountChart from "./components/FollowersEngagementCountChart";
// import FollowersEngagementBestDayChart from "./components/FollowersEngagementBestDayChart";
// import FollowersEngagementRateChart from "./components/FollowersEngagementRateChart";
// import FollowersSentimentTimelineChart from "./components/FollowersSentimentTimelineChart";
// import ContentChart from "./components/ContentChart";
// import ContentDistributionChart from "./components/ContentDistributionChart";
// import ContentTypeChart from "./components/ContentTypeChart";
// import ContentTypeEngagementChart from "./components/ContentTypeEngagementChart";
// import WordCloudChart from "./components/WordCloudChart";
// import ExecutiveSummary from "./components/ExecutiveSummary";

// import NoProfilesSelected from "./components/NoProfilesSelected";
// import { fetchReportData } from "utils/fetchReportData";
// import { predictFutureData } from "utils/prediction";

// import UserService from "services/user-service";

// import dayjs from "dayjs";
// import utc from "dayjs/plugin/utc";
// import timezone from "dayjs/plugin/timezone";

// dayjs.extend(utc);
// dayjs.extend(timezone);

// // ----------------------------------------------------------------------
// // CHART REGISTRY WITH FEATURE MAPPING
// // ----------------------------------------------------------------------
// export const charts = [
//   { id: "executive-summary", title: "Executive Summary", category: "Summary", component: ExecutiveSummary, feature: "Default" },
//   { id: "followers-over-time-chart", title: "Subscribers Over Time", category: "Audience", component: FollowersCountChart, feature: "Audience Report" },
//   { id: "followers-change-over-time-chart", title: "Subscribers Change Over Time", category: "Audience", component: FollowersChangeChart, feature: "Audience Report" },
//   { id: "followers-growth-rate-over-time-chart", title: "Subscribers Growth Rate Over Time", category: "Audience", component: FollowersGrowthRateChart, feature: "Audience Report" },
//   { id: "engagement-over-time-chart", title: "Engagement Over Time", category: "Engagement", component: FollowersEngagementCountChart, feature: "Engagement Report" },
//   { id: "engagement-rate-over-time-chart", title: "Engagement Rate Over Time", category: "Engagement", component: FollowersEngagementRateChart, feature: "Engagement Report" },
//   { id: "engagement-over-day-chart", title: "Engagement Over Day", category: "Engagement", component: FollowersEngagementBestDayChart, feature: "Engagement Report" },
//   { id: "word-cloud-chart", title: "Word Cloud of Comments", category: "Sentiment", component: WordCloudChart, feature: "Word Cloud" },
//   { id: "followers-sentiment-timeline-chart", title: "Sentiment Timeline", category: "Sentiment", component: FollowersSentimentTimelineChart, feature: "Sentiment Timeline" },
//   { id: "content-distribution-chart", title: "Content Distribution", category: "Content", component: ContentDistributionChart, feature: "Default" },
//   { id: "content-type-chart", title: "Content Type", category: "Content", component: ContentTypeChart, feature: "Default" },
//   { id: "content-type-engagement-chart", title: "Content Type Engagement", category: "Content", component: ContentTypeEngagementChart, feature: "Default" },
//   { id: "content-performance-over-time-chart", title: "Content Performance Over Time", category: "Content", component: ContentChart, feature: "Content Drill Down" },
// ];

// // ----------------------------------------------------------------------
// // MAIN COMPONENT
// // ----------------------------------------------------------------------
// function InsightHubContent() {
//   const location = useStableLocation();
//   const navigate = useStableNavigate();

//   const [selectedProfiles, setSelectedProfiles] = useState([]);
//   const uniqueCategories = [...new Set(charts.map(c => c.category))];
//   const [selectedCategories, setSelectedCategories] = useState(uniqueCategories);

//   const [reportData, setReportData] = useState([]);
//   const [adjustedCurrentReportData, setAdjustedCurrentReportData] = useState([]);
//   const [previousReportData, setPreviousReportData] = useState([]);
//   const [adjustedPreviousReportData, setAdjustedPreviousReportData] = useState([]);
//   const [futureReportData, setFutureReportData] = useState([]);
//   const [dateRange, setDateRange] = useState([null, null]);

//   const [isLoading, setIsLoading] = useState(true);

//   // ENTITLEMENTS
//   const [entitlements, setEntitlements] = useState(null);
//   const [requiredPlansMap, setRequiredPlansMap] = useState({});
//   const [userPlan, setUserPlan] = useState("");

//   // CONTENT CHART REF
//   const contentChartRef = useRef(null);

//   // 🚀 MODAL STATE
//   const [showAddProfileModal, setShowAddProfileModal] = useState(false);

//   const DEFAULT_CHART_DAYS = process.env.REACT_APP_DEFAULT_CHART_DAYS
//     ? parseInt(process.env.REACT_APP_DEFAULT_CHART_DAYS, 10)
//     : 14;

//   const [isPredictionEnabled, setIsPredictionEnabled] = useState(false);

//   const handleTogglePrediction = () => setIsPredictionEnabled(p => !p);

//   // ----------------------------------------------------------------------
//   // HANDLERS FOR MODAL
//   // ----------------------------------------------------------------------
//   const handleAddProfileClick = () => {
//     setShowAddProfileModal(true);
//   };

//   const handleCloseModal = () => {
//     setShowAddProfileModal(false);
//   };

//   const handleConfirmAddProfile = (newProfiles) => {
//     // 🚀 FULL SYNC: Since the modal was pre-filled with current selection,
//     // the returned 'newProfiles' is the definitive list (including additions and removals).
//     if (newProfiles) {
//       setSelectedProfiles(newProfiles);
//     }
//     setShowAddProfileModal(false);
//   };

//   // ----------------------------------------------------------------------
//   // FETCH ENTITLEMENTS ONCE
//   // ----------------------------------------------------------------------
//   useEffect(() => {
//     async function loadEntitlements() {
//       try {
//         const res = await UserService.fetchUserEntitlements();
//         setEntitlements(res);

//         setUserPlan(res.plan);
//         setRequiredPlansMap(res.requiredPlans || {});
//       } catch (err) {
//         console.error("Failed loading entitlements:", err);
//       }
//     }
//     loadEntitlements();
//   }, []);

//   // ----------------------------------------------------------------------
//   // Keep existing report fetch logic untouched
//   // ----------------------------------------------------------------------
//   useEffect(() => {
//     if (location.state?.selectedProfiles?.length > 0) {
//       // Only set initial if we haven't modified it yet
//       if (selectedProfiles.length === 0) {
//         setSelectedProfiles(location.state.selectedProfiles);
//       }
//     }
//   }, [location.state]);

//   const fetchDatasets = async (fromRaw, toRaw) => {
//     setIsLoading(true);
//     const tz = dayjs.tz.guess();

//     const fromDate = dayjs(fromRaw).tz(tz).startOf("day").toDate();
//     const toDate = dayjs(toRaw).tz(tz).endOf("day").toDate();
//     const dateDifference = dayjs(toDate).diff(dayjs(fromDate), "day") + 1;

//     const previousToDate = dayjs(fromDate).subtract(1, "day").endOf("day").toDate();
//     const previousFromDate = dayjs(previousToDate).subtract(dateDifference - 1, "day").startOf("day").toDate();

//     const combinedFromDate = dayjs(previousFromDate).subtract(1, "day").startOf("day").toDate();

//     const allData = [];
//     for (const profile of selectedProfiles) {
//       const data = await fetchReportData([profile], combinedFromDate, toDate);
//       allData.push(...data);
//     }
//     const combinedData = allData;

//     const currentData = combinedData.map(profile => ({
//       ...profile,
//       data: profile.data.filter(d => new Date(d.date) >= fromDate && new Date(d.date) <= toDate),
//     }));

//     const adjustedCurrentData = combinedData.map(profile => ({
//       ...profile,
//       data: profile.data.filter(d => {
//         const dt = new Date(d.date);
//         return dt >= dayjs(fromDate).subtract(1, "day").toDate() && dt <= toDate;
//       }),
//     }));

//     const previousData = combinedData.map(profile => ({
//       ...profile,
//       data: profile.data.filter(d => {
//         const dt = new Date(d.date);
//         return dt >= previousFromDate && dt <= previousToDate;
//       }),
//     }));

//     const futureData = predictFutureData(currentData, dateDifference).map(profile => ({
//       ...profile,
//       data: profile.data,
//     }));

//     setReportData(currentData);
//     setAdjustedCurrentReportData(adjustedCurrentData);
//     setPreviousReportData(previousData);
//     setAdjustedPreviousReportData(previousData);
//     setFutureReportData(futureData);
//     setIsLoading(false);
//   };

//   useEffect(() => {
//     if (selectedProfiles.length > 0) {
//       const tz = dayjs.tz.guess();
//       const today = dayjs().tz(tz).endOf("day").toDate();
//       const last = dayjs().tz(tz).subtract(DEFAULT_CHART_DAYS, "day").startOf("day").toDate();
//       setDateRange([last, today]);
//       fetchDatasets(last, today);
//     }
//   }, [selectedProfiles]);

//   const handleDateChange = (newRange) => {
//     const tz = dayjs.tz.guess();
//     const [startRaw, endRaw] = newRange;
//     if (!startRaw || !endRaw) return;

//     const start = dayjs(startRaw).tz(tz).startOf("day").toDate();
//     const end = dayjs(endRaw).tz(tz).endOf("day").toDate();
//     setDateRange([start, end]);
//     fetchDatasets(start, end);
//   };

//   // ----------------------------------------------------------------------
//   // RENDER
//   // ----------------------------------------------------------------------
//   return (
//     <DashboardLayout>
//       <DashboardNavbar />

//       {/* No profiles */}
//       {selectedProfiles.length === 0 ? (
//         <NoProfilesSelected />
//       ) : (
//         <>
//           <Toolbar
//             onDateChange={handleDateChange}
//             onTogglePrediction={handleTogglePrediction}
//             isPredictionEnabled={isPredictionEnabled}
//             chartIds={charts.map(c => c.id)}
//             selectedCategories={selectedCategories}
//             setSelectedCategories={setSelectedCategories}
//             selectedProfiles={selectedProfiles}
//             dateRange={dateRange}
//             contentChartRef={contentChartRef}
//             onAddProfile={handleAddProfileClick}
//             entitlements={entitlements}
//           />

//           {/* Charts Loop */}
//           {charts
//             .filter(c => c.category.toLowerCase() === "summary" || selectedCategories.includes(c.category))
//             .map(chart => {
//               const ChartComponent = chart.component;
//               const isContentChart = chart.id === "content-performance-over-time-chart";

//               // entitlement logic
//               const featureName = chart.feature;
//               let isEntitled = true;
//               let planRequired = "N/A";

//               if (featureName !== "Default") {
//                 const allowed = entitlements?.features || [];
//                 isEntitled = allowed.includes(featureName);
//                 planRequired = entitlements?.requiredPlans?.[featureName] || "Upgrade";
//               }

//               return (
//                 <div id={chart.id} key={chart.id}>
//                   <MDBox pt={0} pb={6}>
//                     <Grid container spacing={3} mt={2}>
//                       <Grid item xs={12} md={12}>
//                         <ChartComponent
//                           title={chart.title}
//                           datasets={reportData}
//                           previousdatasets={previousReportData}
//                           futuredatasets={futureReportData}
//                           adjustedcurrentdatasets={adjustedCurrentReportData}
//                           adjustedpreviousdatasets={adjustedPreviousReportData}
//                           isPredictionEnabled={isPredictionEnabled}
//                           isLoading={isLoading}
//                           selectedCategories={selectedCategories}
//                           ref={isContentChart ? contentChartRef : null}
//                           isEntitled={isEntitled}
//                           featureName={featureName}
//                           planRequired={planRequired}
//                           entitlements={entitlements}
//                         />
//                       </Grid>
//                     </Grid>
//                   </MDBox>
//                 </div>
//               );
//             })}
//         </>
//       )}

//       {/* 🚀 ADD PROFILE MODAL */}
//       <Dialog
//         open={showAddProfileModal}
//         onClose={handleCloseModal}
//         maxWidth="lg"
//         fullWidth
//         PaperProps={{
//           sx: { borderRadius: "12px", height: "80vh" }
//         }}
//       >
//         <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', p: 2 }}>
//           Manage Profiles in Report
//           <IconButton onClick={handleCloseModal}>
//             <CloseIcon />
//           </IconButton>
//         </DialogTitle>
//         <DialogContent sx={{ p: 0, overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
//           <MDBox sx={{ flex: 1, overflowY: 'auto' }}>
//             <SocialStashModal
//               initialSelectedProfiles={selectedProfiles} // 🚀 Pre-select current profiles
//               onConfirmSelection={handleConfirmAddProfile}
//               confirmText="Update Report"
//             />
//           </MDBox>
//         </DialogContent>
//       </Dialog>

//       <WarningPopup />


//       <Footer />
//     </DashboardLayout>
//   );
// }

// export default function InsightHub() {
//   return (
//     <StableLocationProvider>
//       <InsightHubContent />
//     </StableLocationProvider>
//   );
// }


// ######################################################################################

/* comparedly-frontend/src/layouts/insight-hub/index.js */

import React, { useState, useEffect, useRef } from "react";
import { StableLocationProvider, useStableLocation } from "context/StableLocationContext";
import { useStableNavigate } from "context/StableNavigateContext";

import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import Toolbar from "./components/toolbar";

// 🚀 IMPORTS for Modal
import { Dialog, DialogContent, DialogTitle, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SocialStashModal from "layouts/social-stash/SocialStashModal";
import MDTypography from "components/MDTypography";
import SideNavPill from "./components/SideNavPill"; // ✅ Import SideNavPill
import ReportConfiguration from "layouts/social-studio/components/SocialReport/ReportConfiguration"; // [NEW]
import ReportGenService from "services/reportgen-service"; // [NEW] Import ReportGenService
import MDSnackbar from "components/MDSnackbar"; // [NEW] Import MDSnackbar

import AudienceCountChart from "./charts/AudienceCountChart";
import AudienceChangeChart from "./charts/AudienceChangeChart";
import AudienceGrowthChart from "./charts/AudienceGrowthChart"; // ✅ Added
import AudienceViewChart from "./charts/AudienceViewChart";
import AudienceReachChart from "./charts/AudienceReachChart";
import CommentSentimentChart from "./charts/CommentSentimentChart";
import AudienceGrowthRateChart from "./charts/AudienceGrowthRateChart";
import AudienceEngagementCountChart from "./charts/AudienceEngagementCountChart";
import AudienceEngagementBestDayChart from "./charts/AudienceEngagementBestDayChart";
import AudienceEngagementRateChart from "./charts/AudienceEngagementRateChart";
import AudienceSentimentTimelineChart from "./charts/AudienceSentimentTimelineChart";
import ContentChart from "./charts/ContentChart";
import ContentDistributionChart from "./charts/ContentDistributionChart";
import ContentTypeChart from "./charts/ContentTypeChart";
import ContentTypeEngagementChart from "./charts/ContentTypeEngagementChart";
import WordCloudChart from "./charts/WordCloudChart";
import ExecutiveSummary from "./charts/ExecutiveSummary";
import StrategicInsightsChart from "./charts/StrategicInsightsChart"; // [NEW] Gap Analysis

import NoProfilesSelected from "./components/NoProfilesSelected";
import { fetchReportData } from "utils/fetchReportData";
import { predictFutureData } from "utils/prediction";
import { generateColors } from "utils/chartColors"; // ✅ Import utility

import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import UpgradePopup from "layouts/components/Upgrade";
import WarningPopup from "layouts/components/Warning"; // ✅ Import Warning Component
import OptimalContentFrequencyChart from "./charts/OptimalContentFrequncyChart"; // ✅ Added
import OptimalPostingTimeChart from "./charts/OptimalPostingTimeChart"; // ✅ Added
import OptimalContentFormatChart from "./charts/OptimalContentFormatChart"; // ✅ Added
import AudienceAgeChart from "./charts/AudienceAgeChart"; // ✅ Updated Import
import AudienceGenderChart from "./charts/AudienceGenderChart"; // ✅ Added Import
import AudienceCountryChart from "./charts/AudienceCountryChart"; // ✅ Added Import

dayjs.extend(utc);
dayjs.extend(timezone);

// Tutorial Imports
// Tutorial Imports
import InsightHubIntroStep from "layouts/tutorial/steps/InsightHubIntroStep";
import InsightHubGuidanceStep from "layouts/guidance/steps/InsightHubGuidanceStep"; // Top Bar

import { AuthContext } from "context";
import AuthService from "services/auth-service";

// ----------------------------------------------------------------------
// CHART REGISTRY WITH FEATURE MAPPING
// ----------------------------------------------------------------------
// ----------------------------------------------------------------------
// CHART REGISTRY WITH FEATURE MAPPING
// ----------------------------------------------------------------------
export const charts = [
  { id: "executive-summary", title: "Executive Summary", category: "Summary", component: ExecutiveSummary, feature: "Default" },
  { id: "strategic-insights", title: "Strategic Insights", category: "Summary", component: StrategicInsightsChart, feature: "Default" },
  { id: "audience-over-time-chart", title: "Subscribers Over Time", category: "Audience", component: AudienceCountChart, feature: "Audience Report" },
  { id: "audience-change-over-time-chart", title: "Subscribers Change Over Time", category: "Audience", component: AudienceChangeChart, feature: "Audience Report" },
  { id: "audience-growth-chart", title: "Followers Growth Over Time", category: "Audience", component: AudienceGrowthChart, feature: "Audience Report", requirements: { ownProfile: true, allowedPlatforms: ["facebook", "instagram", "youtube"] } }, // ✅ Updated
  { id: "audience-growth-rate-over-time-chart", title: "Subscribers Growth Rate Over Time", category: "Audience", component: AudienceGrowthRateChart, feature: "Audience Report" },
  {
    id: "audience-view-over-time-chart",
    title: "Views Over Time",
    category: "Audience",
    component: AudienceViewChart,
    feature: "Views Chart",
    requirements: { ownProfile: true } // ✅ Updated
  },
  {
    id: "audience-reach-over-time-chart",
    title: "Reach Over Time",
    category: "Audience",
    component: AudienceReachChart,
    feature: "Reach Chart",
    requirements: { ownProfile: true } // ✅ Updated
  },
  {
    id: "audience-age-chart",
    title: "Audience Age Group",
    category: "Demographics", // ✅ Changed Category
    component: AudienceAgeChart,
    feature: "Demographics Report",
    // ✅ NEW REQUIREMENT: Matches user request (Own Profile + Instagram Only + YouTube)
    requirements: { ownProfile: true, allowedPlatforms: ["instagram", "youtube"] }
  },
  {
    id: "audience-gender-chart",
    title: "Audience Gender",
    category: "Demographics",
    component: AudienceGenderChart,
    feature: "Demographics Report",
    // ✅ Matches Age Chart Requirements
    requirements: { ownProfile: true, allowedPlatforms: ["instagram", "youtube"] }
  },
  {
    id: "audience-country-chart",
    title: "Audience Country",
    category: "Demographics",
    component: AudienceCountryChart,
    feature: "Demographics Report",
    // ✅ Matches Age/Gender Requirements
    requirements: { ownProfile: true, allowedPlatforms: ["facebook", "instagram", "youtube"] }
  },
  { id: "engagement-over-time-chart", title: "Engagement Over Time", category: "Engagement", component: AudienceEngagementCountChart, feature: "Engagement Report" },
  { id: "engagement-rate-over-time-chart", title: "Engagement Rate Over Time", category: "Engagement", component: AudienceEngagementRateChart, feature: "Engagement Report" },
  { id: "engagement-over-day-chart", title: "Engagement Over Day", category: "Engagement", component: AudienceEngagementBestDayChart, feature: "Engagement Report" },
  { id: "word-cloud-chart", title: "Word Cloud of Comments", category: "Sentiment", component: WordCloudChart, feature: "Word Cloud" },
  { id: "audience-sentiment-timeline-chart", title: "Sentiment Timeline", category: "Sentiment", component: AudienceSentimentTimelineChart, feature: "Sentiment Timeline" },
  { id: "comment-sentiment-chart", title: "Comment Sentiment Chart", category: "Sentiment", component: CommentSentimentChart, feature: "Comment Sentiment" },
  { id: "content-distribution-chart", title: "Content Distribution", category: "Content", component: ContentDistributionChart, feature: "Default" },
  { id: "content-type-chart", title: "Content Type", category: "Content", component: ContentTypeChart, feature: "Default" },
  { id: "content-type-engagement-chart", title: "Content Type Engagement", category: "Content", component: ContentTypeEngagementChart, feature: "Default" },
  { id: "optimal-content-frequency-chart", title: "Optimal Content Frequency", category: "Content", component: OptimalContentFrequencyChart, feature: "Optimal Content Frequency" },
  { id: "optimal-posting-time-chart", title: "Optimal Posting Time", category: "Content", component: OptimalPostingTimeChart, feature: "Optimal Posting Time" },
  { id: "optimal-content-format-chart", title: "Optimal Content Format", category: "Content", component: OptimalContentFormatChart, feature: "Optimal Content Format" },
  { id: "content-performance-over-time-chart", title: "Content Performance Over Time", category: "Content", component: ContentChart, feature: "Content Drill Down" },
];

// 🚀 HELPER: Check if a chart should be visible based on selected profiles
export const checkChartRequirements = (chart, profiles) => {
  if (!chart.requirements) return true;

  const { ownProfile, allowedPlatforms } = chart.requirements;

  // 1. Check Own Profile Requirement
  if (ownProfile) {
    const hasCompetitor = profiles.some(p => !p.own);
    if (hasCompetitor) return false;
  }

  // 2. Check Allowed Platforms Requirement
  if (allowedPlatforms && allowedPlatforms.length > 0) {
    // Hide if ANY profile is not in the allowed list
    const hasInvalidPlatform = profiles.some(p =>
      !allowedPlatforms.includes(p.platform?.toLowerCase())
    );
    if (hasInvalidPlatform) return false;
  }

  return true;
};

// ----------------------------------------------------------------------
// MAIN COMPONENT
// ----------------------------------------------------------------------
function InsightHubContent() {
  const location = useStableLocation();
  const navigate = useStableNavigate();

  // ... (State declarations are unchanged, keeping them via surrounding context match) ...
  // Re-declaring key state used in logic for clarity in this snippet context is difficult without huge range.
  // We assume the tool will match the start/end correctly.

  const [selectedProfiles, setSelectedProfiles] = useState(location.state?.selectedProfiles || []);

  // ✅ Generate Global Color Map for Consistency
  // 🚀 FIX: Use 'id' as primary key (selectedProfiles uses 'id'), fallback to 'profileId'
  const uniqueProfileIds = selectedProfiles.map(p => p.id || p.profileId);
  const generatedGlobalColors = generateColors(uniqueProfileIds.length, uniqueProfileIds);
  const profileColorMap = {};
  uniqueProfileIds.forEach((id, i) => {
    profileColorMap[id] = generatedGlobalColors[i];
  });

  const uniqueCategories = [...new Set(charts.map(c => c.category))];
  const [selectedCategories, setSelectedCategories] = useState(uniqueCategories);

  const [reportData, setReportData] = useState([]);
  const [adjustedCurrentReportData, setAdjustedCurrentReportData] = useState([]);
  const [previousReportData, setPreviousReportData] = useState([]);
  const [adjustedPreviousReportData, setAdjustedPreviousReportData] = useState([]);
  const [futureReportData, setFutureReportData] = useState([]);
  const [dateRange, setDateRange] = useState([null, null]);
  const [validationAttempt, setValidationAttempt] = useState(0);

  // [NEW] Notification State
  const [notificationSB, setNotificationSB] = useState({
    open: false,
    color: "info",
    icon: "notifications",
    title: "Insight Hub",
    content: "",
  });

  const openNotificationSB = (color, icon, title, content) => {
    setNotificationSB({
      open: true,
      color,
      icon,
      title,
      content,
    });
  };

  const closeNotificationSB = () => setNotificationSB({ ...notificationSB, open: false });

  // Tutorial State
  const { isAuthenticated } = React.useContext(AuthContext);
  const [showTutorial, setShowTutorial] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);

  useEffect(() => {
    if (!isAuthenticated) return;

    const checkTutorial = async () => {
      try {
        const resp = await AuthService.getProfile();
        const userData = resp.data.attributes;
        setCurrentUser(userData);

        const completedSteps = userData.completed_tutorials || [];
        if (!completedSteps.includes("insight_hub_intro")) {
          setShowTutorial(true);
        }
      } catch (error) {
        console.error("Failed to check tutorial status:", error);
      }
    };
    checkTutorial();
  }, [isAuthenticated]);

  const handleCompleteTutorial = async () => {
    try {
      const currentCompleted = currentUser?.completed_tutorials || [];
      if (!currentCompleted.includes("insight_hub_intro")) {
        const updatedTutorials = [...currentCompleted, "insight_hub_intro"];
        await AuthService.updateProfile({
          data: { attributes: { completed_tutorials: updatedTutorials } }
        });
      }
      setShowTutorial(false);
    } catch (error) {
      console.error("Failed to complete tutorial:", error);
      setShowTutorial(false);
    }
  };

  const [isLoading, setIsLoading] = useState(true);
  const [isSavingReport, setIsSavingReport] = useState(false); // [NEW] Loading state for report save

  // ENTITLEMENTS
  const [entitlements, setEntitlements] = useState(null);
  const [requiredPlansMap, setRequiredPlansMap] = useState({});
  const [userPlan, setUserPlan] = useState("");

  const isLiveDemo = sessionStorage.getItem('demo_role_cache') === "demo_viewer"; // [NEW]

  // ✅ NEW STATE FOR HISTORICAL DATA UPGRADE
  const [showHistoryUpgrade, setShowHistoryUpgrade] = useState(false);
  const [historyPlanRequired, setHistoryPlanRequired] = useState("Higher Plan");

  // ✅ NEW STATE FOR WARNING
  const [showHistoryWarning, setShowHistoryWarning] = useState(false);

  // CONTENT CHART REF
  const contentChartRef = useRef(null);

  // 🚀 MODAL STATE
  const [showAddProfileModal, setShowAddProfileModal] = useState(false);
  const [showReportModal, setShowReportModal] = useState(false); // [NEW]

  const DEFAULT_CHART_DAYS = process.env.REACT_APP_DEFAULT_CHART_DAYS
    ? parseInt(process.env.REACT_APP_DEFAULT_CHART_DAYS, 10)
    : 14;

  const [isPredictionEnabled, setIsPredictionEnabled] = useState(false);

  const handleTogglePrediction = () => setIsPredictionEnabled(p => !p);

  // 🚀 LIFTED STATE: Chart View Modes (Daily/Monthly)
  // Dictionary: { "chartId": "daily" | "monthly" }
  const [chartViewModes, setChartViewModes] = useState({});

  const handleViewModeChange = (chartId, mode) => {
    setChartViewModes(prev => ({
      ...prev,
      [chartId]: mode
    }));
  };

  // ----------------------------------------------------------------------
  // HANDLERS FOR MODAL
  // ----------------------------------------------------------------------
  const handleAddProfileClick = () => {
    setShowAddProfileModal(true);
  };

  const handleCloseModal = () => {
    setShowAddProfileModal(false);
  };

  const handleConfirmAddProfile = (newProfiles) => {
    // 🚀 FULL SYNC: Since the modal was pre-filled with current selection,
    // the returned 'newProfiles' is the definitive list (including additions and removals).
    if (newProfiles) {
      setSelectedProfiles(newProfiles);
    }
    setShowAddProfileModal(false);
  };

  // [NEW] Report Handlers
  const handleScheduleReport = () => {
    setShowReportModal(true);
  };

  const handleSaveReport = async (reportData) => {
    try {
      setIsSavingReport(true); // [NEW] Start loading

      // 1. Identify Visible Charts (Same logic as render)
      const visibleChartIds = charts
        .filter(c => c.category.toLowerCase() === "summary" || selectedCategories.includes(c.category))
        .filter(c => checkChartRequirements(c, selectedProfiles))
        .map(c => c.id);

      // 2. Build Chart Configs
      const chartConfigs = {};
      visibleChartIds.forEach(id => {
        chartConfigs[id] = {
          viewMode: chartViewModes?.[id] || "daily"
        };
      });

      // 3. Special Config for Content Chart
      if (visibleChartIds.includes("content-performance-over-time-chart") && contentChartRef.current) {
        if (typeof contentChartRef.current.getCurrentConfig === 'function') {
          const config = contentChartRef.current.getCurrentConfig();
          if (config) {
            chartConfigs["content-performance-over-time-chart"] = {
              ...chartConfigs["content-performance-over-time-chart"],
              ...config
            };
          }
        }
      }

      // Enrich report data with current context
      const payload = {
        ...reportData,
        // Backend expects 'config' not 'configuration'
        // Backend expects 'config' not 'configuration'
        config: {
          selectedProfiles: selectedProfiles.map(p => ({
            id: p.id,
            platform: p.platform,
            name: p.name,
            profilePictureUrl: p.profilePictureUrl
          })),
          visibleCharts: visibleChartIds,
          selectedCategories,
          chartConfigs,
          period: reportData.period || "last_30_days", // [NEW] Pass period
          branding_pack_id: (reportData.branding_pack_id === "system_default" || reportData.branding_pack_id === "") ? null : reportData.branding_pack_id, // [FIX] Include branding
          target_client: reportData.target_client || "", // [FIX] Include target client
          sendImmediate: reportData.sendImmediate || false // [FIX] Use user selection
        }
      };

      await WorkspaceService.createWorkspaceReport(payload);
      // setShowReportModal(false); // [MOVED] Close later

      // [NEW] Check for Immediate Send
      let message = "Your report has been updated and scheduled successfully.";
      let title = "Report Scheduled";

      if (reportData.sendImmediate) {
        // Helper to calculate dates based on period string
        const calculateDateRange = (period) => {
          const toDate = new Date();
          let fromDate = new Date();

          if (period === "last_7_days") fromDate.setDate(toDate.getDate() - 7);
          else if (period === "last_14_days") fromDate.setDate(toDate.getDate() - 14);
          else if (period === "last_3_months") fromDate.setMonth(toDate.getMonth() - 3);
          else fromDate.setDate(toDate.getDate() - 30); // Default last_30_days

          return {
            fromDate: fromDate.toISOString(),
            toDate: toDate.toISOString()
          };
        };

        const periodDates = calculateDateRange(reportData.period || "last_30_days");
        const profileData = payload.config.selectedProfiles.map(p => ({
          profileId: p.id,
          platform: p.platform,
          name: p.name,
          profilePictureUrl: p.profilePictureUrl,
          ...periodDates
        }));

        await ReportGenService.emailReport(
          profileData,
          false, // isPredictionEnabled
          visibleChartIds,
          chartConfigs,
          reportData.recipient_emails || [],
          reportData.branding_pack_id,
          reportData.target_client
        );
        title = "Report Scheduled & Sent";
        message = "Your report has been scheduled and sent to the recipient emails.";
      }

      // [NEW] Trigger Success Notification
      openNotificationSB("success", "check", title, message);

      setShowReportModal(false); // [MOVED] Close only after success

    } catch (err) {
      console.error("Failed to schedule report:", err);
      // Optional: Error notification
      openNotificationSB("error", "warning", "Error", "Failed to schedule report. Please try again.");
    } finally {
      setIsSavingReport(false); // [NEW] Stop loading
    }
  };

  // ----------------------------------------------------------------------
  // FETCH ENTITLEMENTS ONCE
  // ----------------------------------------------------------------------
  useEffect(() => {
    async function loadEntitlements() {
      try {
        const res = await WorkspaceService.fetchWorkspaceEntitlements();
        setEntitlements(res);

        setUserPlan(res.plan);
        setRequiredPlansMap(res.requiredPlans || {});
      } catch (err) {
        console.error("Failed loading entitlements:", err);
      }
    }
    loadEntitlements();

    // ✅ Listen for workspace switches (soft refresh)
    const onProfileUpdated = () => loadEntitlements();
    window.addEventListener("profile-updated", onProfileUpdated);
    return () => window.removeEventListener("profile-updated", onProfileUpdated);
  }, []);

  // ----------------------------------------------------------------------
  // Keep existing report fetch logic untouched
  // ----------------------------------------------------------------------
  useEffect(() => {
    if (location.state?.selectedProfiles?.length > 0) {
      // Only set initial if we haven't modified it yet
      if (selectedProfiles.length === 0) {
        setSelectedProfiles(location.state.selectedProfiles);
      }
    }
  }, [location.state]);

  const fetchDatasets = async (fromRaw, toRaw) => {
    setIsLoading(true);
    const tz = dayjs.tz.guess();

    const fromDate = dayjs(fromRaw).tz(tz).startOf("day").toDate();
    const toDate = dayjs(toRaw).tz(tz).endOf("day").toDate();
    const dateDifference = dayjs(toDate).diff(dayjs(fromDate), "day") + 1;

    const previousToDate = dayjs(fromDate).subtract(1, "day").endOf("day").toDate();
    const previousFromDate = dayjs(previousToDate).subtract(dateDifference - 1, "day").startOf("day").toDate();

    const combinedFromDate = dayjs(previousFromDate).subtract(1, "day").startOf("day").toDate();

    const allData = [];
    for (const profile of selectedProfiles) {
      const data = await fetchReportData([profile], combinedFromDate, toDate);
      allData.push(...data);
    }
    const combinedData = allData;

    const currentData = combinedData.map(profile => ({
      ...profile,
      data: profile.data.filter(d => new Date(d.date) >= fromDate && new Date(d.date) <= toDate),
    }));

    const adjustedCurrentData = combinedData.map(profile => ({
      ...profile,
      data: profile.data.filter(d => {
        const dt = new Date(d.date);
        return dt >= dayjs(fromDate).subtract(1, "day").toDate() && dt <= toDate;
      }),
    }));

    const previousData = combinedData.map(profile => ({
      ...profile,
      data: profile.data.filter(d => {
        const dt = new Date(d.date);
        return dt >= previousFromDate && dt <= previousToDate;
      }),
    }));

    // FIX: adjustedPreviousData must include T-1 baseline (previousFromDate - 1 day)
    const adjustedPreviousData = combinedData.map(profile => ({
      ...profile,
      data: profile.data.filter(d => {
        const dt = new Date(d.date);
        return dt >= dayjs(previousFromDate).subtract(1, "day").toDate() && dt <= previousToDate;
      }),
    }));

    const futureData = predictFutureData(currentData, dateDifference).map(profile => ({
      ...profile,
      data: profile.data,
    }));

    setReportData(currentData);
    setAdjustedCurrentReportData(adjustedCurrentData);
    setPreviousReportData(previousData);
    setAdjustedPreviousReportData(adjustedPreviousData); // Use the corrected dataset
    setFutureReportData(futureData);
    setIsLoading(false);
  };

  useEffect(() => {
    if (selectedProfiles.length > 0) {
      const tz = dayjs.tz.guess();

      // Check if we already have a valid date range (from previous user selection)
      if (dateRange[0] && dateRange[1]) {
        // preserve existing dates and just re-fetch for the new profile list
        fetchDatasets(dateRange[0], dateRange[1]);
      } else {
        // Otherwise, set defaults (Initial Load)
        const today = dayjs().tz(tz).endOf("day").toDate();
        const last = dayjs().tz(tz).subtract(DEFAULT_CHART_DAYS, "day").startOf("day").toDate();
        setDateRange([last, today]);
        fetchDatasets(last, today);
      }
    }
  }, [selectedProfiles]);

  const handleDateChange = (newRange) => {
    const tz = dayjs.tz.guess();
    const [startRaw, endRaw] = newRange;
    if (!startRaw || !endRaw) return;

    // ✅ FORCE SYNC: Increment to reset calendar if invalid
    setValidationAttempt(prev => prev + 1);

    // ✅ HISTORICAL DATA VALIDATION
    if (entitlements?.limits?.historical_data_months) {
      const allowedMonths = entitlements.limits.historical_data_months;
      const start = dayjs(startRaw);
      const today = dayjs();

      // Calculate approximate months back
      const monthsBack = today.diff(start, 'month', true);

      // Add a small buffer for "Close to limit" or strict check. 
      // User asked: "based on value... check if it is within accepted months"
      if (monthsBack > allowedMonths) {
        let suggestedPlan = "Higher Plan";

        // Logic: <= 2 -> Basic, <= 3 -> Pro, <= 12 -> Ultra, > 12 -> Error
        if (monthsBack <= 2) {
          suggestedPlan = "Basic Plan";
        } else if (monthsBack <= 3) {
          suggestedPlan = "Pro Plan";
        } else if (monthsBack <= 12) {
          suggestedPlan = "Ultra Plan";
        } else {
          // Exceeds 12 months - show THEMED WARNING instead of alert
          setShowHistoryWarning(true);
          return;
        }

        setHistoryPlanRequired(suggestedPlan);
        setShowHistoryUpgrade(true);
        return; // 🛑 Prevent date update
      }
    }

    const start = dayjs(startRaw).tz(tz).startOf("day").toDate();
    const end = dayjs(endRaw).tz(tz).endOf("day").toDate();
    setDateRange([start, end]);
    fetchDatasets(start, end);
  };

  // ----------------------------------------------------------------------
  // RENDER
  // ----------------------------------------------------------------------
  return (
    <DashboardLayout>
      <DashboardNavbar />

      {/* No profiles */}
      {selectedProfiles.length === 0 ? (
        <NoProfilesSelected />
      ) : (
        <>
          <Toolbar
            onDateChange={handleDateChange}
            onTogglePrediction={handleTogglePrediction}
            isPredictionEnabled={isPredictionEnabled}
            chartIds={charts.map(c => c.id)}
            selectedCategories={selectedCategories}
            setSelectedCategories={setSelectedCategories}
            selectedProfiles={selectedProfiles}
            dateRange={dateRange}
            contentChartRef={contentChartRef}
            onAddProfile={handleAddProfileClick}
            entitlements={entitlements}
            validationAttempt={validationAttempt}
            chartViewModes={chartViewModes} // ✅ PASS DOWN
            profileColorMap={profileColorMap} // ✅ Pass Global Colors
            onScheduleReport={handleScheduleReport} // [NEW]
          />

          {/* Side Navigation */}
          {selectedProfiles.length > 0 && (
            <SideNavPill
              categories={[...new Set(charts.map(c => c.category))]
                .filter(cat =>
                  (cat.toLowerCase() === "summary" || selectedCategories.includes(cat)) &&
                  // ✅ Filter based on profile requirements
                  charts.filter(c => c.category === cat).some(c => checkChartRequirements(c, selectedProfiles))
                )
              }
            />
          )}

          {/* Grouped Charts Loop */}
          {[...new Set(charts.map(c => c.category))]
            .filter(cat =>
              (cat.toLowerCase() === "summary" || selectedCategories.includes(cat))
            )
            .map((category) => {
              // Get charts for this category
              const categoryCharts = charts.filter(c => c.category === category);

              if (categoryCharts.length === 0) return null;

              // Check if ANY chart in this category is visible (due to restrictions)
              const visibleCharts = categoryCharts.filter(c => {
                // 🚀 REFACTORED: Use shared helper for filtering
                return checkChartRequirements(c, selectedProfiles);
              });

              if (visibleCharts.length === 0) return null;

              return (
                <MDBox key={category} id={`section-${category.replace(/\s+/g, '-').toLowerCase()}`} mb={6}>
                  {/* Section Top Anchor */}
                  <MDBox mb={2} px={1}>
                    <MDTypography variant="h4" fontWeight="bold" textTransform="capitalize" color="dark">
                      {category}
                    </MDTypography>
                    <MDBox
                      sx={{
                        width: "40px",
                        height: "4px",
                        backgroundColor: "#00A1A1",
                        borderRadius: "2px",
                        marginTop: "4px"
                      }}
                    />
                  </MDBox>

                  {visibleCharts.map(chart => {
                    const ChartComponent = chart.component;
                    const isContentChart = chart.id === "content-performance-over-time-chart";

                    // entitlement logic
                    const featureName = chart.feature;
                    let isEntitled = true;
                    let planRequired = "N/A";

                    if (featureName !== "Default") {
                      const allowed = entitlements?.features || [];
                      isEntitled = allowed.includes(featureName);
                      planRequired = entitlements?.requiredPlans?.[featureName] || "Upgrade";
                    }

                    return (
                      <div id={chart.id} key={chart.id}>
                        <MDBox pt={0} pb={6}>
                          <Grid container spacing={3} mt={2}>
                            <Grid item xs={12} md={12}>
                              <ChartComponent
                                title={chart.title}
                                datasets={reportData}
                                previousdatasets={previousReportData}
                                futuredatasets={futureReportData}
                                adjustedcurrentdatasets={adjustedCurrentReportData}
                                adjustedpreviousdatasets={adjustedPreviousReportData}
                                isPredictionEnabled={isPredictionEnabled}
                                isLoading={isLoading}
                                selectedCategories={selectedCategories}
                                ref={isContentChart ? contentChartRef : null}
                                isEntitled={isEntitled}
                                featureName={featureName}
                                planRequired={planRequired}
                                entitlements={entitlements}
                                // 🚀 LIFTED STATE PASSING
                                viewMode={chartViewModes[chart.id] || "daily"}
                                onViewModeChange={(mode) => handleViewModeChange(chart.id, mode)}
                                profileColorMap={profileColorMap} // ✅ Pass Global Colors
                              />
                            </Grid>
                          </Grid>
                        </MDBox>
                      </div>
                    );
                  })}
                </MDBox>
              );
            })}
        </>
      )}

      {/* 🚀 ADD PROFILE MODAL */}
      <Dialog
        open={showAddProfileModal}
        onClose={handleCloseModal}
        maxWidth="lg"
        fullWidth
        disableScrollLock={true}
        PaperProps={{
          sx: { borderRadius: "12px", height: "80vh" }
        }}
      >
        <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', p: 2 }}>
          Manage Profiles in Report
          <IconButton onClick={handleCloseModal}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ p: 0, overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
          <MDBox sx={{ flex: 1, overflowY: 'auto' }}>
            <SocialStashModal
              initialSelectedProfiles={selectedProfiles} // 🚀 Pre-select current profiles
              onConfirmSelection={handleConfirmAddProfile}
              confirmText="Update Report"
            />
          </MDBox>
        </DialogContent>
      </Dialog>

      {/* 🚀 SCHEDULE REPORT MODAL */}
      <Dialog
        open={showReportModal}
        onClose={() => setShowReportModal(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          Save Report
          <IconButton onClick={() => setShowReportModal(false)}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <ReportConfiguration
            defaultReportName={
              selectedProfiles.length > 0
                ? `${selectedProfiles[0].name} Report - ${dayjs().format("MMM DD, YYYY")}`
                : `Social Report - ${dayjs().format("MMM DD, YYYY")}`
            }
            onSave={handleSaveReport}
            onCancel={() => setShowReportModal(false)}
            selectedProfiles={selectedProfiles} // [FIX] Required for Preview
            selectedCategories={selectedCategories} // [FIX] Required for Preview
            isSaving={isSavingReport} // [NEW] Pass loading state
            isLiveDemo={isLiveDemo} // [NEW] Live Demo restriction
            entitlements={entitlements} // [NEW] Pass for Save Report check
          />
        </DialogContent>
      </Dialog>

      {/* ✅ HISTORY LIMIT UPGRADE POPUP */}
      <UpgradePopup
        open={showHistoryUpgrade}
        onClose={() => setShowHistoryUpgrade(false)}
        featureName="Historical Data"
        planRequired={historyPlanRequired}
      />

      {/* ✅ HISTORY LIMIT WARNING POPUP */}
      <WarningPopup
        open={showHistoryWarning}
        onClose={() => setShowHistoryWarning(false)}
        title="Historical Data Limit"
        message="Please select a date range within the last 12 months."
      />

      <Footer />

      {/* 🟢 DEMO GUIDANCE & NEXT STEP */}
      <InsightHubGuidanceStep isLiveDemo={isLiveDemo} />

      {/* Insight Hub Tutorial Popup */}
      <InsightHubIntroStep
        open={showTutorial && !isLiveDemo}
        onComplete={handleCompleteTutorial}
        onSkip={() => setShowTutorial(false)}
        showWorkflowStep={selectedProfiles.length === 0}
      />

      {/* [NEW] Render Snackbar */}
      <MDSnackbar
        color={notificationSB.color}
        icon={notificationSB.icon}
        title={notificationSB.title}
        content={notificationSB.content}
        dateTime="Just now"
        open={notificationSB.open}
        onClose={closeNotificationSB}
        close={closeNotificationSB}
        bgWhite
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      />

    </DashboardLayout>
  );
}

export default function InsightHub() {
  return (
    <StableLocationProvider>
      <InsightHubContent />
    </StableLocationProvider>
  );
}